import React, { useState } from "react";
import { Button, Select, Space, Tooltip } from "antd";
import { CommentsPanel } from "../comments/CommentsPanel";
import { Negotiation, NegotiationStatus } from "../../types/NegotiationTypes";
import { ResourceType } from "../../types/ResourceType";
import { negotiationStatusToString } from "./NegotiationStatusTag";
import { Vendor } from "../../types/VendorTypes";
import { SvgIcon } from "../../common/components/SvgIcon";

interface NegotiationDetailToolboxProps {
    negotiation: Negotiation;
    vendor?: Vendor;
    onStatusChange?: (status: NegotiationStatus) => void;
}

export const NegotiationDetailToolbox: React.FC<NegotiationDetailToolboxProps> = ({
    negotiation,
    vendor,
    onStatusChange,
}) => {
    const [showMessages, setShowMessages] = useState(false);

    const messagesDrawer = (
        <>
            {vendor?.id && (
                <CommentsPanel
                    resourceId={vendor.id}
                    visible={showMessages}
                    resourceType={ResourceType.Vendor}
                    onClose={() => setShowMessages(false)}
                />
            )}
        </>
    );

    return (
        <>
            {messagesDrawer}
            <Space size={10}>
                <Select value={negotiation.status} onSelect={onStatusChange}>
                    {Object.values(NegotiationStatus).map((status) => {
                        return (
                            <Select.Option value={status}>
                                {negotiationStatusToString(status)}
                            </Select.Option>
                        );
                    })}
                </Select>

                <Button
                    type="link"
                    size={"small"}
                    onClick={() => {
                        setShowMessages(true);
                    }}
                    icon={
                        <Tooltip title={"Show comments"} placement="topRight" arrowPointAtCenter={true}>
                            <SvgIcon name="message01" />
                        </Tooltip>
                    }
                ></Button>
            </Space>
        </>
    );
};
